import {TimelineLite} from "gsap";

export class BitMapMultiplier extends PIXI.BitmapText {
    private _value: number;
    private readonly _preFixedText: string | undefined;
    private readonly _postFixedText: string | undefined;

    constructor(fontName: string, fontSize: number, preFixedText?: string, postFixedText?: string) {
        super(" ", {
            fontName: fontName,
            fontSize: fontSize
        });
        this._preFixedText = preFixedText;
        this._postFixedText = postFixedText;
        this.anchor = new PIXI.Point(0.5, 0.5);
        this.value = 1;
    }

    public add(value: number): void {
        this.value = this.value + value;
    }

    // #286
    public doCountUp(to: number, duration: number): TimelineLite {
        const prev: number = parseInt(this.text),
            tl: TimelineLite = new TimelineLite({
                onUpdate: () => this.updateTextProps(parseInt(this.text)),
                onComplete: () => this.updateTextProps(to)
            });
        tl.fromTo(this, {text: prev + "x"}, {text: to + "x", duration: duration});

        return tl;
    }

    private updateTextProps(val: number): void {
        this.text = val + "x";
    }

    public get value(): number {
        return this._value;
    }

    public set value(value: number) {
        this._value = value;
        if (this._preFixedText) {
            this.text = this._preFixedText + value;
        } else if (this._postFixedText) {
            this.text = value + this._postFixedText;
        } else {
            this.text = value.toString();
        }
    }
}